
const resolveImageUrl = (image) => {
  if (!image) return "";
  
  // If it's already a full URL, return it
  if (String(image).startsWith("http://") || String(image).startsWith("https://")) {
    return image;
  }

  const apiBase = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");
  const fallbackImageBase = apiBase.endsWith("/api") ? apiBase.slice(0, -4) : apiBase;
  const rawImageBase = (import.meta.env.VITE_IMAGE_BASE_URL || fallbackImageBase || "").replace(/\/$/, "");
  
  const isBaseLocal = rawImageBase.includes("localhost") || rawImageBase.includes("127.0.0.1") || rawImageBase === "";
  const isWindowLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  
  // Clean the image path
  let cleanImagePath = String(image).replace(/^\//, "");
  // Normalize legacy/badly prefixed paths to backend static route.
  cleanImagePath = cleanImagePath.replace(/^images\/uploads\//i, "uploads/");
  if (!cleanImagePath.startsWith("uploads/")) {
    cleanImagePath = `uploads/${cleanImagePath.replace(/^uploads\//i, "")}`;
  }

  // Normalize base in case env accidentally includes /images or /api/images.
  const normalizedImageBase = rawImageBase.replace(/\/api\/images$/i, "").replace(/\/images$/i, "");

  // If we are in production but the image base points to localhost or is empty,
  // use the current window origin as the base.
  if (typeof window !== "undefined" && !isWindowLocal && isBaseLocal) {
    return `${window.location.origin}/${cleanImagePath}`;
  }

  // If no image base is found at all, use a relative path
  if (!normalizedImageBase) {
    return `/${cleanImagePath}`;
  }

  return `${normalizedImageBase}/${cleanImagePath}`;
};

export default resolveImageUrl;
